/* global axios */
import ApiClient from '../ApiClient';

class DashboardConversationsSummary extends ApiClient {
  constructor() {
    super('dashboard_conversations_summary', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }
}

export default new DashboardConversationsSummary();
